module.exports = __webpack_public_path__ + "ade9c721210c7e15fcc743564dcf4a29.MP3";